import type { FaireProductEntity } from "../../entity_types/product";

export const p_dhpf3uzs9f: FaireProductEntity = {
  token: "p_dhpf3uzs9f",
  type: "product",
  name: "Feathered Friends 13 oz Coffee Mug",
  brandToken: "b_557ocq7k0h",
  brandName: "Allegheny Outfitters",
  imageUrl:
    "https://cdn.faire.com/fastly/027a48cb2a928cd3ef99250ba3d511b8c3825d81bf50d1318f82bb26c7c97660.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/186db13f7aa3fa42edf26af2acf830d733ebf0b6cfb4ebd227058a57c8ab60bc.jpeg",
  ],
  priceDollars: 13.86,
  description:
    "We love watching our feathered friends from the trees above. Even better with a cup of coffee. \n\n13 oz. Hand wash recommended.",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:51.495Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
